<template>
  <div id="app">
    <router-view />
    <section class="imgVerify" v-if="isImgVerify">
      <DragVerify :business="business" @verifySuccess="verifySuccess" ref="dragVerify" />
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// 图形验证
const DragVerify = () => import("./components/dragVerify/index.vue");
import { getCookieVal, setToken, removeToken, setCookieVal, getToken } from "./tool/index";
export default {
  components: { DragVerify },
  created() {
    this.getQuery()
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage, false);
    this.sendMsg()
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage, false);
  },
  computed: {
    ...mapGetters(["isImgVerify", "business"])
  },
  methods: {
    // 获取推广来源数据和搜索引擎来源
    getQuery() {
      // 获取搜索引擎来源
      let searchEngine = this.$route.query.enginesForm || getCookieVal("searchEngine")
      if (searchEngine) {
        setCookieVal("searchEngine", searchEngine, 720)
      } else {
        searchEngine = this.getChannel()
        if (searchEngine) {
          setCookieVal("searchEngine", searchEngine, 720)
        }
      }
      // 获取推广活动来源
      let registerFrom = this.$route.query.registerFrom || getCookieVal("registerFrom")
      if (registerFrom) {
        setCookieVal("registerFrom", registerFrom, 720)
      }
    },
    // 获取渠道来源
    getChannel() {
      let referrer = document.referrer
      let searchEngine
      if (!referrer) {
        return searchEngine = "网址打开"
      }
      let media = ["baidu.com", "so.com", "haosou.com", "sogou.com", "sm.cn", "bing.com", "google.com", "douban.com", "zhihu.com", "toutiao", "weibo.com"]
      for (const key in media) {
        if (referrer.indexOf(media[key]) > 0) {
          switch (media[key]) {
            case "baidu.com":
              searchEngine = "百度"
              break
            case "so.com":
              searchEngine = "360"
              break
            case "haosou.com":
              searchEngine = "好搜"
              break
            case "sogou.com":
              searchEngine = "搜狗"
              break
            case "sm.cn":
              searchEngine = "神马"
              break
            case "bing.com":
              searchEngine = "必应"
              break
            case "google.com":
              searchEngine = "谷歌"
              break
            case "douban.com":
              searchEngine = "豆瓣"
              break
            case "zhihu.com":
              searchEngine = "知乎"
              break
            case "toutiao":
              searchEngine = "头条"
              break
            case "weibo.com":
              searchEngine = "微博"
              break
            default:
              searchEngine = "其他"
              break
          }
          break
        }
      }
      return searchEngine
    },
    // 图形验证成功后
    verifySuccess(data) {
      this.$store.commit("SET_CAPTCHA_KEY", data)
      this.$store.commit("SET_IMG_VERIFY", false)
    },
    // 监听外部页面传入token信息
    receiveMessage(e) {
      if (e.data.type === 'loginOut') {
        console.log('接收清理登录信息-----', e);
        removeToken()
      } else {
        console.log('接收登录信息-----', e);
        // 传入新token
        if (e.data.iyuanwu_token) {
          setToken("iyuanwu_token", e.data.iyuanwu_token)
          setToken("iyuanwu_refreshToken", e.data.iyuanwu_refreshToken)
        }
        if (e.data.iyuanwu_expiration) {
          setToken("iyuanwu_expiration", e.data.iyuanwu_expiration)
        }
      }
    },
    // 向外部发送token信息
    sendMsg() {
      let CAIHONG = this.$route.query?.clientType === 'CAIHONG';
      let token = CAIHONG ? getToken("iyuanwu_token") : getCookieVal("iyuanwu_token");
      if (token || this.$route.query.clientType === 'SAAS') {
        let targetOrigin
        switch (this.$route.query.clientType) {
          case "PORTAL": // 落地页
            targetOrigin = process.env.VUE_APP_PORTAL
            break
          case "CAIHONG": // 彩虹网
            targetOrigin = process.env.VUE_APP_CAIHONG_URL
            break
          case "IYW": // 图案网
            targetOrigin = process.env.VUE_APP_IYWTU
            break
          default: // 默认跳转设计云
            targetOrigin = process.env.VUE_APP_INDEX_URL
            break
        }
        // 父级页面就是本身时不发送
        if (window.parent[0]) {
          console.log('发送登录信息-----', targetOrigin, this.$route.query.clientType);
          window.parent.postMessage({
            iyuanwu_token: !CAIHONG ? getCookieVal("iyuanwu_token") : getToken("iyuanwu_token"),
            iyuanwu_refreshToken: !CAIHONG ? getCookieVal("iyuanwu_refreshToken") : getToken("iyuanwu_refreshToken"),
            iyuanwu_expiration: !CAIHONG ? getCookieVal("iyuanwu_expiration") : getToken("iyuanwu_expiration")
          }, targetOrigin)
        }
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  font-family: PingFangSC, PingFang SC;
  .imgVerify {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    position: fixed;
    background: $blackBg;
    z-index: 9999;
  }
}
</style>
